import { useFormik } from 'formik';
import * as Yup from 'yup';

const LicenseSchema = Yup.object().shape({
  license_id: Yup.number().required('License Type is required'),
  issuer_id: Yup.number().required('License Issuer is required'),
  license_number: Yup.string().required('License Number required'),
  expired_on: Yup.date().required('License Expiration Date is required')
});

export default function useLicenseFormik(onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      license_id: null,
      issuer_id: null,
      license_number: '',
      expired_on: ''
    },
    enableReinitialize: true,
    validationSchema: LicenseSchema,
    onSubmit
  });

  return formik;
}
